<template>
    <g :transform="transform" v-if="show">
        <circle x="-2" y="-2" r="2" :class="ColorMap[color].fill"></circle>
        <circle x="-6" y="-6" r="6" :class="ColorMap[Color.TRANSPARENT].fill" @mouseout="hideInfo()"  @mouseover="showInfo()" class="cursor-pointer"></circle>
    </g>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {Color, ColorMap} from '../types';
    import {useKerncijfersStore} from "../store";
    import tweenValue from "../../../../../lib/Tween";

    interface Tween {
        x: number;
        y: number;
    }
    export default defineComponent({
        name: 'chart-node',
        props: {
            value: {
                type: Number,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            color: {
                type: String as () => Color,
                required: true
            }
        },
        data() {
            return {
                tween: {
                    x: 0,
                    y: 0
                } as Tween,
                ColorMap,
                Color,
                kerncijfersStore: useKerncijfersStore()
            };
        },
        watch: {
            x: function (val) {
                tweenValue(this.tween, "x", val);
            },
            y: function (val) {
                tweenValue(this.tween, "y", val);
            }
        },
        computed: {
            x(): number {
                return this.kerncijfersStore.valueToXPos(this.index);
            },
            y(): number {
                return this.kerncijfersStore.valueToYPos(this.value);
            },
            show(): boolean {
                return !isNaN(this.value);
            },
            transform(): string {
                return 'translate(' + this.tween.x + ', ' + this.tween.y + ')';
            }
        },
        methods: {
            showInfo(): void {
                this.kerncijfersStore.hoveredElement = {
                    x: this.x,
                    y: this.y,
                    value: this.value,
                    bgColor: this.color
                };
            },
            hideInfo(): void {
                this.kerncijfersStore.hoveredElement = null;
            },
            formatEuro(value: number, hasMillions: boolean) {
                let formattedValue = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');

                if (hasMillions) {
                    return formattedValue
                        .replace(/(.+)? 000 000$/, '$1 M')
                        .replace(/^(-)?(\d)00 000$/, '$10,$2 M')
                        .replace(/^(-)?(\d+)(?:\s+)?(\d)00 000$/, '$1$2,$3 M');
                }

                return '€ ' + formattedValue;
            }
        },
        created() {
            this.tween.x = this.x;
            this.tween.y = this.y;
        }
    });
</script>